// extracted by mini-css-extract-plugin
module.exports = {"headerText":"index_headerText_2dwzC","user":"index_user_ohJYN"};